/* eslint-disable */
import { createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      flex: 1,
      marginBottom: 50,
      marginTop: 64,
      "& svg": {
        marginBottom: theme.spacing(4),
      },
    },
    header: {
      fontSize: "25px",
      fontWeight: "bold",
      textAlign: "center",
      maxWidth: "50%",
    },
  });
